'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props as SmartAddAddressProps } from './smart-add-address.component';
import dynamic from 'next/dynamic';

const DynamicAddAddressComponent: ComponentType<SmartAddAddressProps> = dynamic(
  () => import('./smart-add-address.component')
);

export default DynamicAddAddressComponent;

export function calculateAddAddressPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 210 },
    { sinceWidth: 768, height: 230 },
    { sinceWidth: 1024, height: 605 }
  ];

  return {
    heightSinceWidth
  };
}
